import Header from "../website/Header";
import Banner from "../website/Banner";
import ClientLogo from "../website/ClientLogo";
import About from "../website/About";
import Products from "../website/Products";
import Testimonials from "../website/Testimonials";
import Contact from "../website/Contact";
import Footer from "../website/Footer";
import Popup from "../website/Popup";

const Home = () => {
  return (
    <>
      <Header />
      <About />
      <ClientLogo />
      <Banner />
      <Products />
      <Testimonials />
      <Contact />
      <Footer />
      <Popup />
    </>
  );
};

export default Home;
